<div class="wrapper wrapper--{{ withStickyFooter ? 'no-padding-bottom' : '' }}">
  @if (!noClose) {
    <div class="wrapper__close" (click)="close($event)" id="close-popin">
      <app-icon [name]="IconName.close"></app-icon>
    </div>
  }
  <app-loader [hidden]="(showPopinLoader$ | async) === false" [transparent]="false" [withinContent]="true"></app-loader>
  <div class="wrapper__content">
    <ng-content></ng-content>
  </div>
</div>
